import React, { Component } from 'react';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';

import * as Shapes from '../../constants/shapes';

import './SelectionProfileLocation.scss';
import { Icon } from '@salesforce/design-system-react';

class SelectionProfileLocation extends Component {
  constructor(props) {
    super(props);
    this.getI18nID = suffix =>
      `components.ecs.selectionBrowser.location.${suffix}`;
  }

  renderLocation(location) {
    const { formatMessage } = this.props.intl;
    const tags = [
      'Name',
      'City',
      'AdministrativeArea',
      'Country',
      'AdminArea',
      'Latitude',
      'Longitude'
    ]
      .filter(key => !!location[key])
      .map(key => ({
        tagType: formatMessage({ id: this.getI18nID(key) }),
        tagValue: location[key]
      }));

    return (
      <ul>
        {(tags || []).map((tag, idx) => (
          <li
            key={`selection-attribute-tag-${idx}`}
            className="profile-attribute-tag"
          >
            <span className="truncate" title={tag.tagType}>
              {tag.tagType}
            </span>
            <span className="truncate" title={tag.tagValue}>
              {tag.tagValue}
            </span>
          </li>
        ))}
      </ul>
    );
  }

  renderError(err) {
    return (
      <div className="error-pane">
        <div style={{ color: 'black' }}>
          <div className="slds-current-color centered-icon">
            <Icon
              assistiveText={{ label: 'Warning' }}
              category="utility"
              name="warning"
              size="small"
            />
          </div>
        </div>
        <FormattedMessage id={this.getI18nID(err)} />
      </div>
    );
  }

  render() {
    const location = this.props.location || {};
    return (
      <div className="profile-attributes-pane">
        <h1>
          <span>
            <FormattedMessage id="components.ecs.selectionBrowser.location.header" />
          </span>
        </h1>
        {location.error
          ? this.renderError(location.error)
          : this.renderLocation(location)}
      </div>
    );
  }
}

SelectionProfileLocation.propTypes = {
  location: Shapes.Location,
  intl: intlShape.isRequired
};

export default injectIntl(SelectionProfileLocation);
